






















































import { Scrollbar } from '@/app/components';
import { useAxios } from '@/app/composable';
import { ShoppingBagIcon, TagIcon } from '@vue-hero-icons/solid';
import { defineComponent, ref } from '@vue/composition-api';
import { OrbitSpinner } from 'epic-spinners';
import { ContractsAPI } from '../../api';
import WalletTransaction from './WalletTransaction.vue';
export default defineComponent({
    name: 'Wallet',
    components: {
        TagIcon,
        ShoppingBagIcon,
        WalletTransaction,
        Scrollbar,
        OrbitSpinner,
    },
    setup() {
        const transactions = ref<any>([]);
        const assetsObtained = ref<number>(0);
        const assetsShared = ref<number>(0);

        const { exec, loading } = useAxios(true);

        exec(ContractsAPI.getTransactions()).then((res) => {
            if (res?.data) {
                transactions.value = res.data.transactions.reduce((acc: any, transaction: any) => {
                    if (!acc.find((t: any) => t.contractId === transaction.contractId)) acc.push(transaction);
                    return acc;
                }, []);
                assetsObtained.value = res.data.acquiringContracts;
                assetsShared.value = res.data.sellingContracts;
            }
        });

        return { assetsObtained, assetsShared, transactions, loading };
    },
});
